import { Separator } from "@components/ui/separator";

interface BreakpointProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
}

const Breakpoint = ({ title }: BreakpointProps) => (
  <div className="flex items-center gap-4 my-6 h-5">
    {title && (
      <p
        className="text-muted-foreground text-sm"
        data-testid="breakpoint-title"
      >
        {title}
      </p>
    )}
    <Separator className="flex-1" />
  </div>
);

export default Breakpoint;
